
$(document).ready(function() {
  var path = window.location.pathname; // current page path

  // Remove existing active classes
  $(".header__menu li, .header__menu a").removeClass("main-active dropdown-active");

  if (path === "/" || path === "/?") {
    // Home page → highlight Home link only
    $(".header__menu a[href='/']").parent("li").addClass("main-active");
  } else {
    // Other pages → match exact URL
    $(".header__menu a").each(function() {
      var href = $(this).attr("href");
      if (href === path) {
        if ($(this).closest(".dropdown__nav").length) {
          $(this).parent("li").addClass("dropdown-active");
          $(this).closest("details").parent("li").addClass("main-active");
        } else {
          $(this).parent("li").addClass("main-active");
        }
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const input = document.getElementById("live-search-input");
  const results = document.getElementById("live-search-results");

  input.addEventListener("input", function() {
    const query = this.value.trim();

    if (query.length < 2) {
      results.innerHTML = "";
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;

        if (products.length) {
          results.innerHTML = products.map(p => `
            <div class="live-search-item">
              <a href="${p.url}">
                <img src="${p.featured_image.url}" alt="${p.title}">
                <p>${p.title}</p>
              </a>
            </div>
          `).join('');
        } else {
          results.innerHTML = "<p>No products found</p>";
        }
      });
  });
  const footerLinks = document.querySelectorAll(".accordion-details__content a");
  const currentUrl = window.location.pathname;

  footerLinks.forEach(link => {
    if (link.getAttribute("href") === currentUrl) {
      link.classList.add("footer-active");
    }

    // also allow manual click highlight
    link.addEventListener("click", function () {
      footerLinks.forEach(l => l.classList.remove("footer-active"));
      this.classList.add("footer-active");
    });
  });
});




